import { PageWrapper } from "../page-wrapper";
import { Skeleton } from "../ui/skeleton";

export function OverviewSkeleton() {
  return (
    <PageWrapper description="Welcome to Plasma Portal" title="Overview">
      <div className="space-y-6">
        {/* Stats cards */}
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div
              className="border-border bg-background rounded-lg border p-6"
              key={`stat-card-${i.toString()}`}
            >
              <Skeleton className="mb-2 h-4 w-24" />
              <Skeleton className="h-8 w-32" />
            </div>
          ))}
        </div>

        {/* Chart area */}
        <div className="border-border bg-background rounded-lg border p-6">
          <Skeleton className="mb-4 h-6 w-48" />
          <Skeleton className="h-64 w-full" />
        </div>

        {/* Recent activity */}
        <div className="border-border bg-background rounded-lg border p-6">
          <Skeleton className="mb-4 h-6 w-36" />
          <div className="space-y-3">
            {Array.from({ length: 5 }).map((_, i) => (
              <div
                className="flex items-center gap-4"
                key={`activity-row-${i.toString()}`}
              >
                <Skeleton className="size-10 rounded-full" />
                <div className="flex-1 space-y-2">
                  <Skeleton className="h-4 w-3/4" />
                  <Skeleton className="h-3 w-1/2" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}
